import { render, staticRenderFns } from "./TepPostulacionExport.vue?vue&type=template&id=6cab675a"
import script from "./TepPostulacionExport.vue?vue&type=script&lang=js"
export * from "./TepPostulacionExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports